var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.scriptToggle
      ? _c(
          "div",
          {
            staticClass: "script-options menu-bg-blue-transparent",
            attrs: { title: "Admin Only Feature" },
          },
          [
            _c(
              "div",
              { staticClass: "py-2 my-2", attrs: { "no-body": "" } },
              [
                _c(
                  "b-link",
                  {
                    staticClass: "ml-3 admin-text",
                    on: {
                      click: function ($event) {
                        return _vm.toggleDRTAutomation()
                      },
                    },
                  },
                  [_vm._v("\n        DRT/ANSI Automation\n      ")]
                ),
                _vm._v(" "),
                _c("hr", {}),
                _vm._v(" "),
                _c(
                  "b-link",
                  {
                    staticClass: "ml-3 admin-text",
                    on: {
                      click: function ($event) {
                        return _vm.toggleDPRAutomation()
                      },
                    },
                  },
                  [_vm._v("\n        DPR Automation\n      ")]
                ),
              ],
              1
            ),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "home-options menu-bg-blue-transparent" }, [
      _c(
        "div",
        { staticClass: "py-2 my-2", attrs: { "no-body": "" } },
        [
          _vm.globalIsUserAllowed("Change_Password")
            ? _c(
                "b-link",
                {
                  staticClass: "ml-3 white",
                  attrs: {
                    disabled: _vm.disableForTestAccounts(),
                    title: _vm.disableForTestAccounts()
                      ? "Cannot change password of test account"
                      : "",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.initChangePasswordModal()
                    },
                  },
                },
                [_vm._v("\n        Change Password\n      ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.globalIsUserAllowed("Map_Settings") ? _c("hr", {}) : _vm._e(),
          _vm._v(" "),
          _vm.globalIsUserAllowed("Map_Settings")
            ? _c(
                "b-link",
                {
                  staticClass: "ml-3 white",
                  on: {
                    click: function ($event) {
                      return _vm.initMapSettingsMenuModal()
                    },
                  },
                },
                [_vm._v("\n        Map Settings\n      ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.globalIsUserAllowed("Release_History") ? _c("hr", {}) : _vm._e(),
          _vm._v(" "),
          _vm.globalIsUserAllowed("Release_History")
            ? _c(
                "b-link",
                {
                  staticClass: "ml-3 white",
                  on: {
                    click: function ($event) {
                      return _vm.toggleReleaseHistory()
                    },
                  },
                },
                [_vm._v("\n        Release History\n      ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { title: "Admin Only Feature", id: "adminOnlyFeatures" } },
            [
              _vm.globalIsUserAllowed("UAC") ? _c("hr", {}) : _vm._e(),
              _vm._v(" "),
              _vm.globalIsUserAllowed("UAC")
                ? _c(
                    "b-link",
                    {
                      staticClass: "ml-3 admin-text",
                      on: {
                        click: function ($event) {
                          return _vm.toggleUAC()
                        },
                      },
                    },
                    [_vm._v("\n          User Account Control\n        ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.globalIsUserAllowed("Access_Control")
                ? _c("hr", {})
                : _vm._e(),
              _vm._v(" "),
              _vm.globalIsUserAllowed("Access_Control")
                ? _c(
                    "b-link",
                    {
                      staticClass: "ml-3 admin-text",
                      on: {
                        click: function ($event) {
                          return _vm.toggleAccessControlModal()
                        },
                      },
                    },
                    [_vm._v("\n          Access Control\n        ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.globalIsUserAllowed("Release_Version")
                ? _c("hr", {})
                : _vm._e(),
              _vm._v(" "),
              _vm.globalIsUserAllowed("Release_Version")
                ? _c(
                    "b-link",
                    {
                      staticClass: "ml-3 admin-text",
                      on: {
                        click: function ($event) {
                          return _vm.toggleVersionRelease()
                        },
                      },
                    },
                    [_vm._v("\n          Release Version\n        ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.globalIsUserAllowed("MMP_Deliveries")
                ? _c("hr", {})
                : _vm._e(),
              _vm._v(" "),
              _vm.globalIsUserAllowed("MMP_Deliveries")
                ? _c(
                    "b-link",
                    {
                      staticClass: "ml-3 admin-text",
                      on: {
                        click: function ($event) {
                          return _vm.toggleDeliveryModal()
                        },
                      },
                    },
                    [_vm._v("\n          MMP Deliveries\n        ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.globalIsUserAllowed("Automate_Scripts")
                ? _c("hr", {})
                : _vm._e(),
              _vm._v(" "),
              _vm.globalIsUserAllowed("Automate_Scripts")
                ? _c(
                    "b-link",
                    {
                      staticClass: "ml-3 admin-text",
                      on: {
                        click: function ($event) {
                          return _vm.toggleScripts()
                        },
                      },
                    },
                    [
                      _vm._v("\n          Automate Scripts\n          "),
                      _c("fa", {
                        staticClass: "ml-4",
                        attrs: { icon: ["fas", "chevron-right"] },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }